import setHeaders from './setHeaders';
import { successHandler, defaultFailureHandler } from './requestHandlers';
import { CustomErrorHandler, DefaultFailureHandler, RequestParams, UnsuccessfulResponseError } from './types';
import { UserRequestPayload } from '../createUser/types';

const customFetch = <T>({ verb, payload, url }: RequestParams<T>): Promise<Response> =>
  window.fetch(url, {
    method: verb,
    headers: setHeaders(),
    body: JSON.stringify(payload)
  });

/**
 *  Generic function with three generic type parameters:
 * T: The expected success response type
 * S: The type for the request payload (default is UserRequestPayload)
 * U: The expected failure response type (default is the return type of DefaultFailureHandler)
 */
export default <T, S = UserRequestPayload, U = ReturnType<DefaultFailureHandler<S>>>(
  params: RequestParams<S>,
  failureHandler?: CustomErrorHandler<RequestParams<S>, U>): Promise<T | U> =>
  customFetch(params)
    .then((response) => successHandler<T>(response))
    .catch((error) => (failureHandler ?? defaultFailureHandler)(error as UnsuccessfulResponseError, params) as U);

